import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Fade } from 'react-reveal';
import Loading from './../components/loading';
import DeviceIdentifier from 'react-device-identifier';
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';

import ProjectDetail from './projectDetail'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

const ContentStyles = styled.div`
  .status-all {
    transition: all cubic-bezier(0, 0.71, 0.58, 1) .2s 0s;
    opacity: 1;
  }
  .continuous .status2 {
    flex: 0 0 0px !important;
    margin: 0 !important;
    padding: 0 !important;
    opacity: 0;
    width: 0;
  }
  .finished .status1 {
    flex: 0 0 0px !important;
    margin: 0 !important;
    padding: 0 !important;
    opacity: 0;
    width: 0;
  }
  .konutProjectsHome .card {
    border: none;
}
`;

class ProjectHome extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      addClass: null,
      query: 0,
      host: window.location.hostname
    };
  }

  sayHello = (a, b) => {
    this.setState({ addClass: a });
  }

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search).get("st");
    fetch("/json/konutlar.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
            query: query
          });
          this.sayHello(parseInt(this.state.query));
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
    switch (window.location.hostname) {
      case "localhost":
        this.setState({ host: "http://localhost" });
        break;
      case "mortgagetest.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgagetest.emlakkatilim.com.tr" });
        break;
      case "www.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
      default:
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
    }
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {

      let boxClass = ["konutProjectsHome mb-5 pb-5"];
      if (this.state.addClass === 1) {
        boxClass.push('continuous');
      } else if (this.state.addClass === 2) {
        boxClass.push('finished');
      }

      return (
        <>
          <MetaTags>
            <title>Anlaşmalı Konut Projeleri | Emlak Katılım Mortgage</title>
            <meta name="robots" content="all" />
            <meta name="description" content="Emlak Katılım anlaşmalı konut projeleri ve detaylı açıklamalar" />
            <meta property="og:title" content="Anlaşmalı Konut Projeleri | Emlak Katılım Mortgage" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={`${this.state.host}${this.props.location.pathname}`} />
            <meta property="og:image" content={`${this.state.host}/content/images/seo/emlak-logo-facebook-size.jpg`} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:description" content="Emlak Katılım anlaşmalı konut projeleri ve detaylı açıklamalar" />
            <meta property="twitter:card" content="summary" />
            <meta property="twitter:site" content="@tremlakkatilim" />
            <meta property="twitter:title" content="Anlaşmalı Konut Projeleri | Emlak Katılım Mortgage" />
            <meta property="twitter:url" content={`${this.state.host}${this.props.location.pathname}`} />
            <meta property="twitter:image" content={`${this.state.host}/content/images/seo/emlak-logo-twitter-size.jpg`} />
            <meta property="twitter:description" content="Emlak Katılım anlaşmalı konut projeleri ve detaylı açıklamalar" />
          </MetaTags>
          <ContentStyles>
            <Jumbotron className="subpageHeader" fluid>
              <Fade>
                <Container>
                  <h1>Anlaşmalı Konut Projeleri</h1>
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                    <Breadcrumb.Item active>Anlaşmalı Konut Projeleri</Breadcrumb.Item>
                  </Breadcrumb>
                </Container>
              </Fade>
            </Jumbotron>
            <Container className={boxClass.join(' ')}>
              <Fade bottom cascade>
                <Row>
                  <Col>
                    <h2>Anlaşmalı Konut Projeleri</h2>
                  </Col>
                  <Col className="d-none d-lg-block d-md-block">
                    <Nav className="ml-auto float-right">
                      <Nav.Link onClick={this.sayHello.bind(this, 0)}>Tümü</Nav.Link>
                      <Nav.Link onClick={this.sayHello.bind(this, 1)}>İnşaatı Devam Eden</Nav.Link>
                      <Nav.Link onClick={this.sayHello.bind(this, 2)}>İnşaatı Tamamlanan</Nav.Link>
                    </Nav>
                  </Col>
                </Row>
                <Row>
                  {
                    items.map((projects, i) => {
                      return (
                        <Col className={`mb-4 status-all status${projects.status}`} md={4} data-index={i} key={i}>
                          <DeviceIdentifier isDesktop={true}>
                            <Card className="text-white">
                              <a href={'anlasmali-konut-projeleri/' + projects.guid}>
                                <Card.Img src={`/projects/${projects.guid}/${projects.featuredimage}`} alt={projects.name} />
                              </a>
                              <Card.ImgOverlay>
                                <Card.Title className="mt-3">{projects.name}</Card.Title>
                                <Card.Text>{projects.summary}</Card.Text>
                                <Button href={'anlasmali-konut-projeleri/' + projects.guid} variant="outline-secondary">İNCELE</Button>
                              </Card.ImgOverlay>
                            </Card>
                          </DeviceIdentifier>
                          <DeviceIdentifier isMobile={true} isTablet={true}>
                            <Card className="bg-dark text-white">
                              <a className="imageContainer" href={'anlasmali-konut-projeleri/' + projects.guid}>
                                <Card.Img src={`/projects/${projects.guid}/${projects.featuredimage}`} alt={projects.name} />
                              </a>
                              <Card.Body>
                                <Card.Title className="mt-3">{projects.name}</Card.Title>
                                <Card.Text>{projects.summary}</Card.Text>
                                <Button href={'anlasmali-konut-projeleri/' + projects.guid} variant="outline-primary">İNCELE</Button>
                              </Card.Body>
                            </Card>
                          </DeviceIdentifier>
                        </Col>
                      );
                    })
                  }
                </Row>
              </Fade>
            </Container >
          </ContentStyles>
        </>
      );
    }
  }
}

const Projects = () => {
  return (
    <>
      <Router>
        <Route exact path="/anlasmali-konut-projeleri" component={ProjectHome} />
        <Route path="/anlasmali-konut-projeleri/:konutId" component={ProjectDetail} />
      </Router>
    </>
  );
};

export default Projects;